/**
 * SPEC-20260507-0136 (Fase 3): wrappers REST de saga-definitions + step-catalog.
 */

import { apiFetch } from "./auth";
import type {
  SagaDefinitionView,
  SagaStepDefinition,
  DiffEntry,
  StepCatalogEntry,
} from "../types/saga-definition";

interface ApiSuccess<T> { success: true; data: T }

export async function listSagaDefinitions(filters: { name?: string; active?: boolean } = {}): Promise<SagaDefinitionView[]> {
  const qs = new URLSearchParams();
  if (filters.name) qs.set("name", filters.name);
  if (filters.active !== undefined) qs.set("active", String(filters.active));
  const path = qs.toString() ? `/api/saga-definitions?${qs}` : "/api/saga-definitions";
  const r = await apiFetch<ApiSuccess<SagaDefinitionView[]>>(path);
  return r.data;
}

export async function getSagaDefinition(id: string): Promise<SagaDefinitionView> {
  const r = await apiFetch<ApiSuccess<SagaDefinitionView>>(`/api/saga-definitions/${id}`);
  return r.data;
}

export async function getActiveSagaDefinition(name: string): Promise<SagaDefinitionView> {
  const r = await apiFetch<ApiSuccess<SagaDefinitionView>>(`/api/saga-definitions/${name}/active`);
  return r.data;
}

export async function listSagaDefinitionVersions(name: string): Promise<SagaDefinitionView[]> {
  const r = await apiFetch<ApiSuccess<SagaDefinitionView[]>>(`/api/saga-definitions/${name}/versions`);
  return r.data;
}

export async function diffSagaDefinitions(
  name: string,
  from: number,
  to: number,
): Promise<{ from: number; to: number; entries: DiffEntry[] }> {
  const r = await apiFetch<ApiSuccess<{ from: number; to: number; entries: DiffEntry[] }>>(
    `/api/saga-definitions/${name}/diff?from=${from}&to=${to}`,
  );
  return r.data;
}

export async function createSagaDefinition(input: {
  name: string;
  description?: string;
  steps: SagaStepDefinition[];
}): Promise<SagaDefinitionView> {
  const r = await apiFetch<ApiSuccess<SagaDefinitionView>>("/api/saga-definitions", {
    method: "POST",
    body: JSON.stringify(input),
  });
  return r.data;
}

export async function activateSagaDefinition(id: string): Promise<SagaDefinitionView> {
  const r = await apiFetch<ApiSuccess<SagaDefinitionView>>(
    `/api/saga-definitions/${id}/activate`,
    { method: "POST", body: "{}" },
  );
  return r.data;
}

export async function archiveSagaDefinition(id: string): Promise<SagaDefinitionView> {
  const r = await apiFetch<ApiSuccess<SagaDefinitionView>>(
    `/api/saga-definitions/${id}/archive`,
    { method: "POST", body: "{}" },
  );
  return r.data;
}

export async function getStepCatalog(): Promise<StepCatalogEntry[]> {
  const r = await apiFetch<ApiSuccess<StepCatalogEntry[]>>("/api/step-catalog");
  return r.data;
}
